import { makeCommonStore, FormField } from '../commons'
import ProfileService from '@/services/ProfileService.js'

export default {
  ...makeCommonStore(
    {
      status: null,
      service: ProfileService,
      requiredFields: [
        new FormField({
          name: 'surname',
          label: 'Surname',
          icon: 'label_important',
          md: 12
        }),
        new FormField({
          name: 'firstname',
          label: 'First names',
          icon: 'label_important',
          md: 12
        }),
        new FormField({
          name: 'date_birth',
          type: 'date',
          label: 'Date of birth',
          md: 12
        })
      ],
      fields: [
        new FormField({
          name: 'id',
          hidden: true
        }),
        new FormField({
          name: 'signature',
          hidden: true
        }),
        new FormField({
          name: 'verified',
          hidden: true
        }),
        new FormField({
          name: 'title',
          type: 'select',
          label: 'Title',
          icon: 'person',
          items: [
            { text: 'Mr', value: 'Mr' },
            { text: 'Mrs', value: 'Mrs' },
            { text: 'Miss', value: 'Miss' },
            { text: 'Ms', value: 'Ms' }
          ],
          cols: 4,
          sm: 3,
          md: 2
        }),
        new FormField({
          name: 'surname',
          label: 'Surname *',
          rules: [ 'required' ],
          cols: 8,
          sm: 9,
          md: 4
        }),
        new FormField({
          name: 'firstname',
          icon: 'label_important',
          rules: [ 'required' ],
          label: 'First names *',
          cols: 8,
          sm: 8,
          md: 6
        }),
        new FormField({
          name: 'date_birth',
          type: 'date',
          rules: [ 'required' ],
          value: '',
          label: 'Date of birth *'
        }),
        new FormField({
          name: 'email',
          icon: 'email',
          rules: [ 'email' ],
          label: 'Email (if different from signin)'
        }),
        new FormField({
          name: 'address',
          type: 'address',
          rules: [ 'required' ],
          value: '',
          label: 'Address *',
          text: ''
        }),
        new FormField({
          name: 'mailing_address',
          type: 'address',
          value: '',
          label: 'Mailing address',
          text: '',
          hidden: true
        }),
        new FormField({
          name: 'spouse_name',
          icon: 'person_outline',
          label: 'Spouse\'s name (if applicable)',
          hidden: true
        }),
        new FormField({
          name: 'home_phone',
          icon: 'phone',
          label: 'Home number',
          hidden: true
        }),
        new FormField({
          name: 'mobile',
          icon: 'fa-mobile-alt',
          rules: [ 'required' ],
          label: 'Mobile *'
        }),
        new FormField({
          name: 'work_mobile',
          icon: 'phone',
          label: 'Work number',
          hidden: true
        }),
        new FormField({
          name: 'fax',
          icon: 'fa-fax',
          label: 'Fax',
          hidden: true
        })
      ]
    }
  ),
  namespaced: true
}
